import React from "react";
import Button from "@source/components/UI/buttons/button/button";
import {ConsentDocument} from "@source/api/models/consentModels";
import {clinicalPresentationPath, isClinicalOnSiteImmediatelyActiveAfterSend, isResidentImmediatelyActiveAfterSend, residentPresentationPath} from "@source/api/models/consentHelpers";
import styles from "./consentSteps.module.scss";

export const SentConsentStep = ({document, residentId, onLater}: {
  document: ConsentDocument;
  residentId: string;
  onLater: () => void;
}) => {
  const presentResident = isResidentImmediatelyActiveAfterSend(document);
  const presentClinical = isClinicalOnSiteImmediatelyActiveAfterSend(document);
  const sentCopy = presentClinical && presentResident
    ? "The GP / Clinician and the resident are ready to review this consent document in person."
    : presentClinical
      ? "The GP / Clinician is ready to review this consent document in person."
      : "The resident is ready to review this consent document in person.";
  return <div className={styles.steps}>
    <section className={styles.sentNext}>
      <h2>Consent document sent</h2>
      <p>{sentCopy}</p>
      <div className={styles.actions}>
        <Button variant="outlined" onClick={onLater}>Present later</Button>
        {presentClinical ? <Button event="link" link={clinicalPresentationPath(residentId, document._id)}>Present to GP / Clinician now</Button> : null}
        {presentResident ? <Button event="link" link={residentPresentationPath(residentId, document._id)}>Present to resident now</Button> : null}
      </div>
    </section>
  </div>;
};
